import Component from "vue-class-component";
import Vue from "vue";
import providers from "@/lib/providers";

@Component
export default class WithEmailVerification extends Vue {
  public emailVerificationFind({ userId }: { userId: string[] }) {
    return providers.EmailVerificationProvider.find({ userId });
  }

  public emailVerificationVerify({ data }: { data: { userId: string; code: string } }) {
    return providers.EmailVerificationProvider.verify({ data });
  }

  public emailVerificationFindById(userId: string): Promise<boolean> {
    // @ts-ignore
    return this.emailVerificationFind({ userId: [userId] }).then(r => r[userId] || false);
  }

  public emailVerificationStart(userId: string) {
    return providers.EmailVerificationProvider.start({ userId });
  }

  public emailVerificationSetVerified(userId: string) {
    return providers.EmailVerificationProvider.setVerified({ userId });
  }
}
